// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3111":"css/admin-app.7054","9106":"css/app.7054"}[chunkId] + ".css";
};